import { Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { type FC } from "react";

/** @deprecated We are phasing out `cc-ui` */
export const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.brand.grey["800"].main,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  // some italics characters need a little extra space so they don't get cut off
  width: "calc(100% + 0.125ch)",
}));

const tNoFile = "No File Chosen";

/** @deprecated We are phasing out `cc-ui` */
const getFileNames = (files: FileList) => {
  const res = [];
  for (const file of files) {
    res.push(file.name);
  }
  return res;
};

/** @deprecated We are phasing out `cc-ui` */
interface WrappedFileNameProps {
  fileNames: string[];
}

/** @deprecated We are phasing out `cc-ui` */
const WrappedFileName: FC<WrappedFileNameProps> = ({ fileNames }) => {
  const fileName = fileNames.join(",");
  return (
    <Tooltip arrow title={fileName}>
      <Text data-testid="file-upload-filename" fontWeight="bold" variant="body2">
        {fileName}
      </Text>
    </Tooltip>
  );
};

/** @deprecated We are phasing out `cc-ui` */
export interface FileNameProps {
  files?: FileList | null;
}

/** @deprecated We are phasing out `cc-ui` */
export const FileName: FC<FileNameProps> = ({ files }) => {
  if (!files || files.length === 0) {
    return (
      <Text data-testid="file-upload-no-file" fontStyle="italic">
        {tNoFile}
      </Text>
    );
  }

  if (files.length === 1) {
    return <WrappedFileName fileNames={[files[0].name]} />;
  }

  if (files.length > 1) {
    return <WrappedFileName fileNames={getFileNames(files)} />;
  }

  return (
    <Text data-testid="file-upload-no-file" fontStyle="italic">
      {tNoFile}
    </Text>
  );
};
